import type { Page } from "./types.js";

/** Delta P2-D1 - exhaust list cursors before Active Project tier selection. */
export const collectAllPages = async <T>(
  fetchPage: (cursor: string | null) => Promise<Page<T>>,
): Promise<readonly T[]> => {
  const items: T[] = [];
  let cursor: string | null = null;
  for (;;) {
    const page = await fetchPage(cursor);
    items.push(...page.items);
    if (page.nextCursor === null) {
      break;
    }
    cursor = page.nextCursor;
  }
  return items;
};
